import React,{useEffect, useState} from "react";
import { ItemDefaultV2 } from "../Products/Item";
import {getHotdeal} from "../../service/hotdealService";
import {responsiveproductlist, chunkArray} from "../../utils/constant";


import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const Hotdeal1 =()=>{
    const [hotdealData, setHotdealData] = useState([]);
    const loadData=()=>{
        let param = {
            div:  null,
            brands: null,
            group: null,
            hotdeal_date: null,
            current_page: 0,
            per_page: 100
          };
          try {
            getHotdeal(param).then((response) => {
              if(response.status && response.status === 200){
                setHotdealData(response['message']);
              }
            });     
          } catch(err) {
            console.error(err);
          }  
    }
    useEffect(()=>{
        loadData();
    },[]);
    if(hotdealData.length > 0){
    return(
        <div className="hot__deal">
        <div className="container m-auto p-0">
            <div className="row p-0 row--maint m-0 pb-4" >
                <div className="col-12 px-0">
                    <div className="maint__title">
                        <div className="row m-0">
                            <div className="maint__title--left col-3 px-0">
                                <h2 className="float-start fw-bold">Hot Deal</h2>
                            </div>
                            <div className="maint__title--right col-9 px-0">
                                <div className="float-end position-relative"><a href="/hot-deal.html">Xem tất cả </a><i className="fa-solid fa-chevron-right"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 p-0">
                    <div className="mant__item my-auto hot--deal">
                        <div className="row m-0 p-0 position-relative">
                           <Carousel key="CarouselHotdeal"
                            responsive={responsiveproductlist}
                            autoPlay={false}
                            fade={true}
                            infinite={true}
                            slidesToSlide={4}
                            swipeable={true}
                            rewind={true}
                            >
                                { 
                                hotdealData?.map((item, index)=>(
                                    <ItemDefaultV2 key={index} item={item} index={index} showPriceRow='false' showpercen='true' hotdel='true'/>
                                ))
                                } 
                            </Carousel>
                        </div>
                    </div>
                </div>
                 {/* <div className="col-12 p-0">
                 <div className="position-relative">
                        <Carousel key="CarouselHotdeal"
                            responsive={responsiveproductlist}
                            autoPlay={false}
                            fade={true}
                            >
                            {
                                 chunkArray(hotdealData, 5).map((group, groupIndex) => (
                                                <div>
                                             {
                                                group?.map((item, index)=>(
                                                    <div key={index} className="col-2 p-0">
                                                    <ItemDefaultV2 key={index} item={item} index={index} showPriceRow='false' showpercen='true'/>
                                                    </div>
                                                ))
                                             }
                                        </div>
                                 ))
                            }
                    </Carousel>
                </div>
                </div> */}
            </div>
        </div>  
    </div>
    )
}else{
        return null;
    }
}
export default Hotdeal1;